import { render, staticRenderFns } from "./CollabList.vue?vue&type=template&id=6c0b91ff&scoped=true"
import script from "./CollabList.vue?vue&type=script&lang=js"
export * from "./CollabList.vue?vue&type=script&lang=js"
import style0 from "./CollabList.vue?vue&type=style&index=0&id=6c0b91ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b91ff",
  null
  
)

export default component.exports